import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import {isFutureDate} from "../../../../util/dates";
import "./Date.css";
import "react-datepicker/dist/react-datepicker.css";
registerLocale("es", es);

function DateQuestionary({ question, onUpdateAnswer, invalidKeys }) {
  const [startDate, setStartDate] = useState();
  const [showPicker, setShowPicker] = useState(false);
  const [na, setNa] = useState(false);
  const isInvalid = invalidKeys.includes(question.key);

  function handleNa() {
    setNa(true);
    setShowPicker(false);
    updateAnswer("NA");
  }

  function handleDate(date) {
    if (
      !question.checkFutureDate ||
      isFutureDate(date.toISOString().split("T")[0])
    ){
      setStartDate(date);
      updateAnswer(date);
    } else {
      setShowPicker(false);
      alert("No puedes seleccionar una fecha anterior a hoy.");
    }
    
  }

  function updateAnswer(date) {
    const answer = {
      key: question.key,
      answer: date === "NA" ? "NA" : new Date(date.toDateString()),
      question: question.description,
      type: question.answersType,
    };
    onUpdateAnswer(answer);
  }

  return (
    <div className={isInvalid ? "error" : "mainDate"}>
      <p className="dateQuestion">{question.description}</p>
      <div
        className={showPicker ? "selectedDateButton" : "dateButton"}
        onClick={() => {
          setShowPicker(true);
          setNa(false);
        }}
      >
        <span className="dateButtonText">Seleccionar fecha</span>
      </div>
      {question.optional && (
        <div
          className={na ? "selectedDateButton" : "dateButton"}
          onClick={handleNa}
        >
          <span className="dateButtonText">No aplica</span>
        </div>
      )}
      {showPicker && (
        <DatePicker
          selected={startDate}
          onChange={(date) => handleDate(date)}
          locale="es"
          placeholderText="Seleccione una fecha"
        />
      )}
    </div>
  );
}

export default DateQuestionary;
